import {ComponentFactoryResolver, Directive, EmbeddedViewRef, Inject, Input, Renderer2, TemplateRef, ViewContainerRef} from '@angular/core';
import {MxInformationTooltipConfig, MxInfoTooltipComponent} from '../../../modules/mx-info-tooltip/components/mx-info-tooltip.component';
import {MX_INFORMATION_SERVICE_TOKEN, MxInformationService} from '../../services/mx-information.service';

@Directive({
    selector: '[mxInfo]',
    standalone: false,
})
export class MxInfoDirective {

    private infoConfig: MxInformationTooltipConfig;
    private embeddedViewRef: EmbeddedViewRef<any>;

    constructor(
        @Inject(MX_INFORMATION_SERVICE_TOKEN) private boInformationService: MxInformationService,
        private content: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private renderer: Renderer2,
        private componentFactoryResolver: ComponentFactoryResolver,
    ) {

    }

    @Input('mxInfo')
    private set setKey(infoKey: string) {
        this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.content, this);
        if (!infoKey) {
            return;
        }

        this.boInformationService.getInformationConfigs(infoKey)
            .subscribe(value => {
                if (value) {
                    this.infoConfig = value;
                    this.createInfoBlock();
                }
            });
    }

    private createInfoBlock(): void {

        const firstRootNode = this.embeddedViewRef.rootNodes[0];
        firstRootNode.innerHTML = '';
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MxInfoTooltipComponent);
        const componentRef = this.viewContainer.createComponent(componentFactory);
        componentRef.instance.config = this.infoConfig;
        this.renderer.appendChild(firstRootNode, componentRef.location.nativeElement);
    }

}
